import { render, staticRenderFns } from "./StudentLimitSettingsHeader.vue?vue&type=template&id=66a1b0a9&scoped=true&"
import script from "./StudentLimitSettingsHeader.vue?vue&type=script&lang=ts&"
export * from "./StudentLimitSettingsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StudentLimitSettingsHeader.vue?vue&type=style&index=0&id=66a1b0a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a1b0a9",
  null
  
)

export default component.exports